function hasAnyRole(user, roles) {
  return Boolean(user?.roles?.some((role) => roles.includes(role)));
}

function withToken(base, goto, token) {
  return `${base}${goto || ""}?t=${token}`;
}

export function resolveLoginDestination(user, token, goto, env, adminRoles) {
  if (hasAnyRole(user, ["ROLE_WORKER"])) {
    return withToken(env.WORKER, goto, token);
  }
  if (hasAnyRole(user, ["ROLE_EMPLOYEE"])) {
    return withToken(env.FRONT, goto, token);
  }
  if (hasAnyRole(user, adminRoles)) {
    return `${env.ADMIN}?t=${token}`;
  }
  if (hasAnyRole(user, ["ROLE_COMPANY"])) {
    return withToken(env.COMPANY, goto || "/", token);
  }

  return null;
}
